<template>
  <div class="home-wrapper position-relative">
    <div class="home">
      <div class="blue-gradient">
      </div>
      <div class="orange-gradient position-fixed">
      </div>
      <b-row>
        <b-col md="8" class="intro">
          <h1>Process optimization and analytics for cement</h1>
          <p>Cement is the construction material of choice, however, the industry accounts
          for about 7% of global CO2 emissions. Companies have several options to
          decarbonize cement, such as new production technologies, alternative fuels and
          leveraging process optimization strategies like MPC (Model Predictive Control)</p>
          <!--
          <p>Cement companies report the drive to adapt in a constantly changing market.
          Explore this interactive tool to learn how you can address challenges in the
          cement industry with Model Predictive Control.</p>
          -->
          <b-button pill variant="outline-primary" :to="'Explore'">EXPLORE</b-button>
        </b-col>
      </b-row>
    </div>
    <trends />
  </div>
</template>

<script>
import Trends from '@/components/Trends'

export default {
  components: { Trends },
  mounted () {
    this.$store.commit('showLogo', true)
  },
  name: 'Home'
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  padding: 3%;
  background: url('../assets/img/benefits/still.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.home-wrapper {
  height: 100%;
}
</style>
